export let routes = [
  {
    path: '/x3-side-sell-prices',
    name: 'x3-side-sell-prices',
    component: () => import('./sell-prices.vue'),
    meta: {
      vx_animate: 'none',
    },
  },
];

export let api = {
  xsSellPrices(options) {
    return new Promise((resolve, reject) => {
      app.router.push(
        '/x3-side-sell-prices',
        route => {
          route.meta._resolve = resolve;
          route.meta._reject = reject;
          route.meta.options = options;
        },
        err => {
          console.log(err);
        }
      );
    });
  },
};
